import TableLite from "@/components/table/TableLiteTs.vue";
import { ListUploadResponse } from "@/domain/upload.model";
import { UtilDate } from "@/helpers/date";
import { UploadService } from "@/services/upload.service";
import { reactive } from "vue";
import { Options, Vue } from "vue-class-component";
import { useToast } from "vue-toastification";

@Options({
  components: {
    TableLite,
  },
})
export default class Upload extends Vue {
  public type: string = "";
  public file: File | null = null;
  public errors: { type?: string; file?: string } = {};
  public files: ListUploadResponse;
  public table = TABLE;
  private toast = useToast();

  public validate(): boolean {
    let valid = true;
    this.errors = {};

    if (!this.type) {
      this.errors.type = "Este campo deve ser preenchido.";
      valid = false;
    }

    if (!this.file) {
      this.errors.file = "Este campo deve ser preenchido.";
      valid = false;
    }

    return valid;
  }

  public async handleSubmit(): Promise<void> {
    if (!this.validate()) {
      return;
    }

    try {
      const response = await UploadService.upload({ type: this.type, file: this.file });

      if (response.success) {
        this.toast.success("Upload realizado com sucesso!", { timeout: false });
        await this.getFiles();
      } else {
        this.toast.error("Falha ao realizar o upload.", { timeout: false });
      }
    } catch (error) {
      const message = error.response?.data?.message || "Erro ao fazer upload.";

      this.toast.error(message, { timeout: false });
    }
  }

  public onFileChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      this.file = target.files[0];
    }
  }

  public async getFiles(): Promise<void> {
    try {
      const response = await UploadService.getFiles();
      this.table.rows = response;
    } catch (error) {
      const message = error.response?.data?.message || "Erro ao carregar o arquivo.";

      this.toast.error(message, { timeout: false });
    }
  }

  public mounted(): void {
    this.getFiles();
  }

  public formatDate(date: string | Date): string {
    return date ? UtilDate.format(date, "DD/MM/YYYY HH:mm:ss") : "";
  }
}

export const TABLE = reactive({
  isLoading: false,
  columns: [
    { field: "file", label: "Arquivo" },
    { field: "type", label: "Tipo" },
    { field: "status", label: "Status" },
    { field: "createdAt", label: "Enviado em" },
    { field: "createdBy", label: "Enviado por" },
  ],
  rows: [{}] as ListUploadResponse[],
});
